import { render, staticRenderFns } from "./ManageCustomer.vue?vue&type=template&id=3c22b1bb"
import script from "./ManageCustomer.vue?vue&type=script&lang=ts"
export * from "./ManageCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports